import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { header } from "./tile.module.scss";

const TileHeader = ({ className, ...props }) => (
  <header className={classNames(header, className)} {...props} />
);

TileHeader.propTypes = {
  className: PropTypes.string
};

TileHeader.defaultProps = {
  className: ""
};

export default TileHeader;
